const reviewsSiteId = {
    goldenPages: 5,
    goldenPagesSurveys: 18,
    mishlohim: 24,
    rest: 2,
    doctors: 8,
    mithatnim: 1,
    hoogel: 29
  };

export default Object.freeze(reviewsSiteId);